export default {
    config: {
        apiKey: "AIzaSyBIcm_yEvVF8S-1349nck1vXgxBOM_o4jw",
        authDomain: "buzon-ayuntamiento.firebaseapp.com",
        databaseURL: "https://buzon-ayuntamiento.firebaseio.com",
        projectId: "buzon-ayuntamiento",
        storageBucket: "buzon-ayuntamiento.appspot.com",
        messagingSenderId: "102266282928",
        appId: "1:102266282928:web:fe13050e7c74471ee56c75"
    }
}